<template>
  <SubContent  @back="back">
    <template v-slot:nav_left>
      <div style="display: flex; align-items: center" class="teachTitleList">
        <div>
          <span>优秀苗子推荐列表--{{playerName}}</span>
        </div>
      </div>
    </template>

    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <template v-if="userRole === 'coach'">
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeSquadUuid(selectVal.squadUuid)"
            >
              <option value="">全部球队</option>
              <option
                v-for="(item, index) in selectsquadList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </template>
          <template v-else>
            <select
              v-model="selectVal.organUuid"
              class="yioks_select"
              @change="changeOrg"
            >
              <option v-if="organList.length > 1" value="">全部会员协会</option>
              <option
                v-for="item in organList"
                :key="item.organUuid"
                :value="item.organUuid"
              >
                {{ item.organShortName }}
              </option>
            </select>
            <select
              v-model="selectVal.youthUuid"
              class="yioks_select"
              @change="changeCenter"
            >
              <option v-if="centerList.length !== 1" value="">
                全部培训机构
              </option>
              <option
                v-for="item in centerList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.youthShortName }}
              </option>
            </select>
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option v-if="squadList.length !== 1" value="">全部球队</option>
              <option
                v-for="item in squadList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.shortName }}
              </option>
            </select>
          </template>
          <select v-model="selectVal.dataType" class="yioks_select" @change="changeQuery(true)" >
            <option value='' >全部类型</option>
            <option value='player' >球员</option>
            <option value='goalkeeper' >守门员</option>
          </select>
          <select v-model="selectVal.competition" class="yioks_select" @change="changeQuery(true)" >
            <option value='' >全部赛事</option>
            <option
              v-for="item in competitionList"
              :key="item.uuid"
              :value="item.competitionName"
            >
              {{ item.competitionName }}
            </option>
          </select>
          <select v-model="selectVal.scoreOrder" class="yioks_select" @change="changeQuery(true)" >
            <option value='' >全部排序</option>
            <option value="ASC">分数升序</option>
            <option value="DESC">分数降序</option>
          </select>
        </div>

      </div>
      <div class="select_wrap">
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="scout-countent">
        <yioks-loading v-if="isLoading"></yioks-loading>
        <template v-else>
          <yioks-empty v-if="isEmpty"></yioks-empty>
          <div class="list_wrap" v-else>
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th line-unit">单位</div>
                  <div class="th line-name">姓名</div>
                  <div class="th line-idnumber">证件号</div>
                  <div class="th line-time">比赛名称与场次</div>
                  <template v-if="userRole === 'coach'">
                    <div class="th line-info">状态</div>
                  </template>
                  <template v-else>
                    <div class="th line-info">评价人</div>
                  </template>

                  <template v-if="isHisCfaCoach">
                    <div class="th line-info">评价人</div>
                  </template>
                  <template v-else>
                    <div class="th line-info">类型</div>
                  </template>
                  <div class="th line-score">分数</div>
                  <div class="th line-action">操作</div>
                </div>
              </div>
              <vue-scroll>
                <div class="scroll-area">
                  <div class="tbody-wrap">
                    <div class="tbody">
                      <div class="t_content">
                        <div
                          class="tr"
                          v-for="item in scoutList"
                          :key="item.uuid"
                        >
                          <div
                            class="td line-unit"
                            :title="item.organShortName + item.youthShortName"
                          >
                            <p>
                              {{ item.youthShortName }}
                            </p>
                          </div>
                          <div class="td line-name">
                            <p :class="{ focusPlayer: ((['system','admin'].includes(userRole) || isHisCfaCoach) && item.focus === 1)}">{{ item.playerName }}</p>
                          </div>
                          <template v-if="item.playerUuid && (userRole === 'admin' || userRole === 'system')">
                            <div class="td line-idnumber">
                              <p class="btn" @click="jumpToPlayer(item)">{{ item.playerIdNumber }}</p>
                            </div>
                          </template>
                          <template v-else>
                            <div class="td line-idnumber">
                              <p>{{ item.playerIdNumber }}</p>
                            </div>
                          </template>

                          <div class="td line-time">
                            <p :title="item.competition">{{ item.competition }}</p>
                          </div>

                          <template v-if="userRole === 'coach'">
                            <div class="td line-info">
                              <p>{{ item.dataStatus | statusFilter }}</p>
                            </div>
                          </template>
                          <template v-else-if="userRole === 'expert'">
                            <div class="td line-info">
                              <p>{{ item.scoutName }}</p>
                            </div>
                          </template>
                          <template v-else>
                            <div class="td line-info">
                              <p >{{ item.scoutName }}</p>
                            </div>
                          </template>

                          <template v-if="isHisCfaCoach">
                            <div class="td line-info">
                              <p >{{ item.scoutName }}</p>
                            </div>
                          </template>
                          <template v-else>
                            <div class="td line-info">
                              <p>{{ item.dataType === 'goalkeeper' ? "守门员" : "球员" }}</p>
                            </div>
                          </template>
                          <div class="td line-score">
                            <p >{{ item.scoutScore || '--' }}</p>
                          </div>
                          <div class="td line-action">
                            <p>
                              <template v-if="uuid === item.userUuid">
                                <span
                                  v-if="
                                    item.dataStatus &&
                                    item.dataStatus === 'complete'
                                  "
                                  class="item"
                                  @click="goInfo(item)"
                                >
                                  查看
                                </span>
                                <span
                                  v-if="
                                    item.dataStatus &&
                                    item.dataStatus === 'incomplete'
                                  "
                                  class="item"
                                  @click="editCenter(item)"
                                >编辑</span
                                >
                                <span class="split">/</span>
                                <span class="item" @click="toDeleteItem(item)"
                                >删除</span
                                >
                              </template>
                              <template v-else>
                                <span
                                  v-if="
                                    item.dataStatus &&
                                    item.dataStatus === 'complete'
                                  "
                                  class="item"
                                  @click="goInfo(item)"
                                >
                                  查看
                                </span>
                                <span v-else> -- </span>
                              </template>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
        </template>
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page" />
      <yioks-tip
        :showTip="isShowDeleteTips"
        tipMsg="确定删除该数据吗？"
        @callback="deleteBack"
      />
      <el-dialog
        :visible.sync="batchAdd"
        width="500px"
        title="选择球员"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        custom-class="yioks_alert2"
      >
        <el-form ref="batchInfo" :model="batchInfo" label-width="130px">
          <vue-scroll ref="scroll" :ops="ops">
            <div style="margin-right: 30px">
              <el-form-item label="是否精英机构球员"  class="yioks-switch-grey">
                <el-switch
                  v-model="isStuExit"
                  active-text="是"
                  inactive-text="否"
                  active-color="#4cd964"
                  @change="changeSwitch"
                ></el-switch>
              </el-form-item>

              <template v-if="isStuExit">
                <template v-if="userRole === 'coach'">
                  <el-form-item
                    label="选择球队"
                    prop="unitId"
                    :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]"
                  >
                    <el-select
                      v-model.trim="batchInfo.unitId"
                      style="width: 100%"
                      no-data-text="暂时没有球队，请前往球队管理添加球队"
                      :placeholder="$t('teamPlaceholder')"
                      @change="changeUnitUUid"
                    >
                      <el-option
                        v-for="(item, index) in selectsquadList"
                        :key="index"
                        :label="item.label"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item
                    label="管理协会"
                    required
                    prop="organUuid"
                    :rules="[{ required: true, message: '必填项' }]"
                  >
                    <el-select
                      v-model.trim="batchInfo.organUuid"
                      style="width: 100%"
                      placeholder="请选择管理协会"
                      @change="changeBathOrg"
                    >
                      <el-option
                        v-for="(item, index) in batchOrganList"
                        :key="index"
                        :value="item.organUuid"
                        :label="item.organShortName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="单位"
                    required
                    prop="youthUuid"
                    :rules="[{ required: true, message: '必填项' }]"
                  >
                    <el-select
                      v-model.trim="batchInfo.youthUuid"
                      style="width: 100%"
                      placeholder="请选择管理协会后再选择单位"
                      @change="changeBathCenter"
                    >
                      <el-option
                        v-for="item in batchCenterList"
                        :key="item.uuid"
                        :value="item.uuid"
                        :label="item.youthShortName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="选择球队"
                    required
                    prop="squadUuid"
                    :rules="[{ required: true, message: '必填项' }]"
                  >
                    <el-select
                      v-model.trim="batchInfo.squadUuid"
                      style="width: 100%"
                      placeholder="请选择球队"
                      no-data-text="暂时没有球队，请前往球队管理添加球队"
                      @change="changeTeam"
                    >
                      <el-option
                        v-for="item in batchSquadList"
                        :key="item.uuid"
                        :value="item.uuid"
                        :label="item.shortName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <el-form-item
                  label="选择球员"
                  required
                  prop="playerUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.playerUuid"
                    style="width: 100%"
                    placeholder="请选择球员"
                    no-data-text="暂时没有球员，请前往球员管理添加球员"
                    filterable
                    @change="playerChange"
                  >
                    <el-option
                      v-for="(item, index) in playerList"
                      :key="index"
                      :value="item.uuid"
                      :label="item.uname"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="场上主要位置" prop="position"
                    :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]">
                  <el-select v-model="batchInfo.position" class="w_100" placeholder="请选择场上主要位置">
                    <el-option v-for="item in positionList" :key="item.uuid" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="球员姓名" prop="player_name"
                  :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-input v-model="batchInfo.player_name" placeholder="请输入球员姓名"></el-input>
                </el-form-item>
                <el-form-item label="证件号" prop="player_id_number"
                  :rules="[{ required: true, message: '必填项', trigger: 'blur' }, {
                    required: true, validator: checkIdnumber, trigger: ['blur', 'change']
                  }]">
                  <el-input v-model="batchInfo.player_id_number" placeholder="请输入证件号"></el-input>
                </el-form-item>
                <el-form-item label="场上主要位置" prop="position"
                    :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]">
                  <el-select v-model="batchInfo.position" class="w_100" placeholder="请选择场上主要位置">
                    <el-option v-for="item in positionList" :key="item.uuid" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </div>
          </vue-scroll>
        </el-form>
        <div class="btn-wrapper">
          <el-button type="primary" @click="toAddScout">添加优秀苗子信息</el-button>
        </div>
      </el-dialog>
    </template>
  </SubContent>
</template>

<script>
  import squad from "@/api/squad";
  import scout from "@/api/scout";
  import player from "@/api/player";
  import storage from "@/utils/storage";
  import {ops} from "@/utils/scrollIndialog";
  import formRules from '@/utils/formRules/rules'; // src\utils\formRules\rules.js
  export default {
  name: "ScoutList",

  data() {
    return {
      ops,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      playerName : this.$route.query.playerName,
      total: 0,
      page: 0,
      pageSize: 20,

      selectVal: {
        organUuid: "",
        youthUuid: "",
        dataType: "",
        competition: "",
        scoreOrder: "",
        seacherString: "",
        squadUuid: "",
      },
      isLoading: false,
      isEmpty: false,
      competitionList: [],
      batchOrganList: [], // 管理协会列表
      batchCenterList: [], // 单位列表
      batchSquadList: [], //  球队列表
      playerList: [], //球员列表
      batchInfo: {
        organUuid: "", // 协会
        organShortName: "",
        youthUuid: "", // 机构
        youthShortName: "",
        squadUuid: "", // 球队
        playerUuid: "", // 球员
        unitId: "", // 联合信息
        player_name: "",
        player_id_number: "",
        position: "",
      }, // 弹窗表单

      batchAdd: false, // 弹窗

      scoutList: [], // table的数据

      organList: [],
      centerList: [],
      squadList: [],
      isShowDeleteTips: false,
      deleteUuid: "",
      selectsquadList: [],

      isStuExit: true,
      positionList: [],
      isHisCfaCoach:storage.get("isCfaCoach")
    };
  },

  components: {
    SubContent: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
  },

  created() {
    this.setQueryData();
    this.playerCompetitionList();
    if (this.userRole !== "coach") {
      this.getOrganListAndCenterList();
    } else {
      this.getSquadList();
    }
    // this.getOrganListAndCenterList();
    // this.loadScoutInfoList();
    this.changeQuery();

    // 获取场上位置
    this.loadPositionInfo();
  },
  filters: {
    statusFilter(val) {
      let tips = "";
      switch (val) {
        case "incomplete":
          tips = "未完善";
          break;
        case "complete":
          tips = "已完成";
          break;
        default:
          tips = "信息异常";
          break;
      }
      return tips;
    },
  },

  watch: {
      page () {
        this.changeQuery()
      },
  },

  methods: {
    back(){
      this.$router.go(-1);
    },
    playerCompetitionList(){
      scout
      .getScoutCompetition()
      .then((res) => {
        this.competitionList = res;
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
    checkIdnumber: (rules, val, callback) => {
      console.log('formRules.idNumber(val)', formRules.idNumber(val))
      if(formRules.idNumber(val)) {
        callback()
      } else {
        callback('证件号错误')
      }
    },
    setQueryData() {
      const { organUuid, youthUuid, squadUuid,dataType,seacherString ,competition,page,playerUuid,playerName,scoreOrder} = this.$route.query;
      organUuid && this.$set(this.selectVal, "organUuid", organUuid);
      youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
      squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
      dataType && this.$set(this.selectVal, "dataType", dataType);
      competition && this.$set(this.selectVal, "competition", competition);
      seacherString && this.$set(this.selectVal, "seacherString", seacherString);
      playerUuid && this.$set(this.selectVal, "playerUuid", playerUuid);
      scoreOrder && this.$set(this.selectVal, "scoreOrder", scoreOrder);
      playerName && (this.playerName = playerName);
      page && (this.page = Number(page));
    },

    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          playerName: this.playerName,
          page: this.page,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
          playerUuid: this.selectVal.playerUuid,
          dataType: this.selectVal.dataType,
          competition: this.selectVal.competition,
          seacherString: this.selectVal.seacherString,
          scoreOrder: this.selectVal.scoreOrder,
        },
      });
      this.loadScoutInfoList();
    },

    changeSquadUuid(val) {
      this.changeQuery(true);
    },

    changeOrg(val) {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },

    changeCenter(val) {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },

    /* 添加球探 == 球员弹窗 */
    openAddDialog() {
      this.batchAdd = true;
    },
    /* 添加球探 */
    toAddScout() {
       let queryData = {};
      this.batchInfo.player_id_number = this.batchInfo.player_id_number.trim().toUpperCase();
      this.batchInfo.player_name = this.batchInfo.player_name.trim();
      if(this.isStuExit) {
         let { organShortName, youthShortName, playerUuid, unitId, position, ...rest } =
            this.batchInfo;
          queryData = {
            playerUuid,
            position: position,
            ...rest,
          };
          if (unitId) {
            const { organUuid, squadUuid, youthUuid } = JSON.parse(unitId);
            queryData = Object.assign({}, queryData, {
              organUuid,
              squadUuid,
              youthUuid,
            });
          }
      } else {
         let { player_name, player_id_number, position } = this.batchInfo;
         queryData = {
           player_name, player_id_number, position
         }
      }
      // console.log('queryData', queryData)
      // return
      this.$refs.batchInfo.validate((valid) => {
        if(valid) {
          if(this.isStuExit){
            this.$router.push({
              name: "ScoutAdd",
              query: queryData,
            });
          }else{
            scout
            .scoutPlayerDataVerify(this.batchInfo.player_id_number,this.batchInfo.player_name)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$router.push({
                  name: "ScoutAdd",
                  query: queryData,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
          }
        } else {
//          this.$message.warning("请先选择球员");
        }
      })

    },

    /* 机构选择 */
    changeBathOrg(val) {
      this.batchSquadList = [];
      this.batchCenterList = [];
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "organShortName", "");
      this.$set(this.batchInfo, "youthShortName", "");
      this.$set(this.batchInfo, "squadUuid", "");
      if (this.batchInfo.organUuid) {
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        if (this.batchCenterList.length === 1) {
          // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          if (this.batchSquadList.length === 1) {
            this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          }
        }
      }
    },

    /* 单位变化 */
    changeBathCenter(val) {
      this.batchInfo.squadUuid = "";
      this.batchSquadList = [];
      this.batchInfo.youthShortName = "";
      if (this.batchInfo.youthUuid) {
        this.batchInfo.youthShortName =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).youthShortName || "";
        this.batchSquadList =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).squadList || [];
        // if (this.batchSquadList.length === 1) {
        //   this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
        // }
      }
    },

    /* 球队变化 */
    changeTeam(val) {
      if (val) {
        player
          .getSquadPlayer(val)
          .then((res) => {
            this.playerList = res.map((item) => ({
              uuid: item.uuid,
              uname: item.idName,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    changeSwitch(){
      this.$refs['batchInfo'].clearValidate();
    },
    changeUnitUUid(val) {
      if (val) {
        const {
          organShortName,
          organUuid,
          shortName,
          squadUuid,
          youthShortName,
          youthUuid,
        } = JSON.parse(val);
        if (!squadUuid) {
          throw new Error("squadUuid is error:", squadUuid);
          return;
        }
        player
          .getSquadPlayer(squadUuid)
          .then((res) => {
            this.playerList = res.map((item) => ({
              uuid: item.uuid,
              uname: item.idName,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    /* 获取协会列表 */
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        // request = squad.getOrgListByCoachOrLeader;
        // console.log('在created方法中，短路此方法')
      }
      request(data).then((res) => {
        this.batchOrganList = res;
        this.organList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
                this.changeTeam(this.squadList[0].uuid);
              }
            }
          }
        }
      });
    },

    getSquadList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.selectsquadList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
            value: item.squadUuid,
            key: JSON.stringify({
              squadUuid: item.squadUuid,
              youthUuid: item.youthUuid,
              organUuid: item.organUuid,
              organShortName: item.organShortName,
              youthShortName: item.youthShortName,
              shortName: item.shortName,
            }),
          }));
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    /* 获取球探报告列表 */
    loadScoutInfoList() {
      this.isLoading = true;
      this.isEmpty = false;
      let requestName = "";
      if (this.userRole === "organ") {
        requestName = scout.getScoutListByOrg;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        requestName = scout.getScoutListPlayerSystem;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        requestName = scout.getScoutListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach" || this.userRole === "expert") {
        requestName = scout.getScoutListByTeacher;
      }
      const pageObj = {
        page: this.page,
        size: this.pageSize,
        ...this.selectVal,
      };

      requestName(pageObj)
        .then((res) => {
          this.isLoading = false;
          let data = res.content;
          this.total = res.totalElements;
          if (data.length) {
            this.scoutList = data;
          } else {
            this.isEmpty = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /* 球员变化 */
    playerChange(val) {
      //   console.log("球员", val);
    },

    /* 查看 */
    goInfo(row) {
      const { uuid, playerUuid } = row;

      this.$router.push({
        name: "ScoutDetails",
        query: {
          dataUuid: uuid,
          playerUuid: playerUuid,
        },
      });
    },
    /* 编辑 */
    editCenter(row) {
      const { uuid, playerUuid } = row;
      this.$router.push({
        name: "EditInfo",
        query: {
          dataUuid: uuid,
          playerUuid: playerUuid,
        },
      });
    },

    /* 删除球探报告 */
    toDeleteItem(row) {
      const { uuid } = row;
      this.deleteUuid = uuid;
      this.isShowDeleteTips = true;
    },

    deleteBack(sure) {
      if (sure) {
        scout
          .deleteScout(this.deleteUuid)
          .then((res) => {
            this.loadScoutInfoList();
            this.isShowDeleteTips = false;
          })
          .catch((err) => {
            console.error(err);
            this.isShowDeleteTips = false;
          });
      } else {
        this.isShowDeleteTips = false;
      }
    },

    jumpToCoach(row) {
      if(this.userRole === 'admin' || this.userRole === 'system'){
        const { userUuid } = row;
        this.$router.push({
          path: '/coach/info',
          query: {
            uuid: userUuid
          }
        })
      } else {
        return
      }
    },

    jumpToPlayer(row) {
      if(this.userRole === 'admin' || this.userRole === 'system'){
        const { playerUuid } = row;
        this.$router.push({
          path: '/player/info',
          query: {
            uuid: playerUuid
          }
        })
      } else {
        return
      }
    },

    /* 获取position定位 */
    loadPositionInfo() {
      const params = {};
      player
        .allPositionList(params)
        .then((res) => {
          this.positionList = res.map((item) => ({
            uuid: item.uuid,
            name: item.playerPositionName,
          }));
        })
        .catch((err) => {
          console.error(res);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.yioks_select
  width:127px !important
.yioks_input
  width:140px !important
.select_wrap
  padding 20px 40px 0 40px
.scout-countent
  height 480px
  margin-top 40px
  .list_wrap
    height 100%
    flex 1
    overflow hidden
    .table
      display flex
      flex 1
      flex-direction column
      width 100%
      .thead
        margin 0 40px
        border 1px solid white
        border-bottom none
        .tr
          height 45px
          display flex
      .scroll-area
        height 370px
      .tbody-wrap
        display block
      .tbody
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width 810px
        border-top none
        border-bottom none
        .t_content
          margin-bottom 30px
          .tr
            height 49px
            display flex
            border 1px solid $color_white
            border-bottom none
            &:first
              border-top none
            &:last-child
              border-bottom 1px solid $color_white
      .th, .td
        height 100%
        /* flex: 1 1 auto; */
        display flex
        justify-content center
        align-items center
        font-size $font_size_medium
        border-right 1px solid $color_white
      .th:last-child, .td:last-child
        border-right none
      .td
        p
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
          color $color_white
          text-align center
          width 100%
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
        .focusPlayer
          color #f88594 !important
.btn-wrapper
  display flex
  justify-content center
.line-unit
  width 20%
.line-name
  width 10%
.line-time
  width 16%
.line-info
  width 8%
  .btn
    color $green_color !important
    cursor pointer
.line-score
  width 6%
  .btn
    color $green_color !important
    cursor pointer
.line-idnumber
  width 21%
  .btn
    color $green_color !important
    cursor pointer
.line-action
  width 11%
.w_100
  width 100%
</style>

<style lang="stylus">
@import '~@/assets/css/variable'

.yioks-switch
  .el-switch__label
    color: $color_white
  .el-switch__label--left
    &.is-active
      color: $color_white
  .el-switch__label--right
    &.is-active
      color: $green_color
.yioks-switch-grey
  .el-switch__label
    color: $grey_color
  .el-switch__label--left
    &.is-active
      color: $grey_color
  .el-switch__label--right
    &.is-active
      color: $green_color
</style>
